$(function(){

    var $supportForm = $('.support-form');

    if ($supportForm.length){
        var browserInfo = window.navigator.userAgent,
            $browrserInput = $supportForm.find('input[name=browserinfo]');
        $browrserInput.val(browserInfo);
    }

});